import React from 'react';

import Input from 'components/input/input';
import FormattedMessage from 'components/formatted-message';
import PropsFormatter, { tr } from 'containers/props-formatter';

import { AuthContainer, AuthError, AuthForm, AuthHeader, AuthSubmitButton, AuthText } from '../components/auth-layout';
import { AuthOptionLinks, LOGIN_AUTH_LINK, SIGN_UP_AUTH_LINK } from '../auth-option-links';
import { isEmailFilled, isUsernameFilled } from '../helpers/auth-form';

import { useForgotPassword } from './use-forgot-password';

const AUTH_LINKS = [SIGN_UP_AUTH_LINK, LOGIN_AUTH_LINK] as const;

/** /forgot-password: a reset link by email (the link leads to /set-password) */
const ForgotPassword = () => {
    const {
        email,
        setEmail,
        username,
        setUsername,
        validationMode,
        needsUsername,
        submitEnabled,
        handleSubmit,
        pending,
        success,
        failed
    } = useForgotPassword();

    return (
        <AuthContainer>
            <AuthForm onSubmit={handleSubmit}>
                <AuthHeader>
                    <FormattedMessage id="forgotPassword.title" />
                </AuthHeader>

                {success ? (
                    <AuthText>
                        <FormattedMessage id="forgotPassword.successNotification" />
                    </AuthText>
                ) : (
                    <>
                        <PropsFormatter
                            validationPredicate={validationMode && isEmailFilled}
                            placeholder={tr('forgotPassword.email')}
                        >
                            <Input
                                type="text"
                                value={email}
                                onChange={event => setEmail(event.target.value)}
                                unbounded
                                disabled={needsUsername}
                            />
                        </PropsFormatter>

                        {!!needsUsername && (
                            <>
                                <AuthText>
                                    <FormattedMessage id="forgotPassword.usernameRequired" />
                                </AuthText>
                                <PropsFormatter
                                    validationPredicate={validationMode && isUsernameFilled}
                                    placeholder={tr('forgotPassword.username')}
                                >
                                    <Input
                                        type="text"
                                        value={username}
                                        onChange={event => setUsername(event.target.value)}
                                        unbounded
                                    />
                                </PropsFormatter>
                            </>
                        )}

                        <AuthSubmitButton
                            type="submit"
                            disabled={pending || (validationMode && !submitEnabled)}
                            isLoading={pending}
                        >
                            <FormattedMessage id="forgotPassword.button" />
                        </AuthSubmitButton>
                    </>
                )}

                {!!failed && (
                    <AuthError>
                        <FormattedMessage id="forgotPassword.error" />
                    </AuthError>
                )}
            </AuthForm>
            <AuthOptionLinks linksToShow={AUTH_LINKS} />
        </AuthContainer>
    );
};

export default ForgotPassword;
